/**
 * @deprecated Will be removed in a future SDK.
 */
export { createStaticNavigation } from './createStaticNavigation';
/**
 * @deprecated Use `Link` from `expo-router` instead. Will be removed in a future SDK.
 */
export { Link } from './Link';
export { LinkingContext } from './LinkingContext';
/**
 * @deprecated Use the `I18nManager` API from `react-native` to read or override the layout
 * direction. Will be removed in a future SDK.
 */
export { LocaleDirContext } from './LocaleDirContext';
/**
 * @deprecated `ExpoRoot` mounts the `NavigationContainer` automatically — there is no need
 * to render one manually in an Expo Router app. For tests, use `renderRouter` from
 * `expo-router/testing-library`. Will be removed in a future SDK.
 */
export { NavigationContainer } from './NavigationContainer';
/**
 * @deprecated Server-side rendering for Expo Router is handled by `@expo/server` and the
 * Expo Router static renderer. Will be removed in a future SDK.
 */
export { ServerContainer } from './ServerContainer';
/**
 * @deprecated Import `DarkTheme` from `expo-router` instead. Will be removed in a future SDK.
 */
export { DarkTheme } from './theming/DarkTheme';
/**
 * @deprecated Import `DefaultTheme` from `expo-router` instead. Will be removed in a future SDK.
 */
export { DefaultTheme } from './theming/DefaultTheme';
export * from './types';
export { UnhandledLinkingContext as UNSTABLE_UnhandledLinkingContext } from './UnhandledLinkingContext';
/**
 * @deprecated Use `Link` from `expo-router`. Will be removed in a future SDK.
 */
export { useLinkBuilder } from './useLinkBuilder';
/**
 * @deprecated Use `Link` from `expo-router`. Will be removed in a future SDK.
 */
export { type LinkProps, useLinkProps } from './useLinkProps';
/**
 * @deprecated Use `useRouter` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useLinkTo } from './useLinkTo';
/**
 * @deprecated Use the `I18nManager` API from `react-native` to read locale direction.
 * Will be removed in a future SDK.
 */
export { useLocale } from './useLocale';
/**
 * @deprecated Import `useRoutePath` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useRoutePath } from './useRoutePath';
/**
 * @deprecated Import `useScrollToTop` from `expo-router` instead. Will be removed in a future SDK.
 */
export { useScrollToTop } from './useScrollToTop';
export * from '../core';
